/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const OpEnum = zod
    .enum(['add', 'remove', 'replace', 'move', 'copy', 'test'])
    .describe(
        '\* `add` - add\n\* `remove` - remove\n\* `replace` - replace\n\* `move` - move\n\* `copy` - copy\n\* `test` - test',
    );

export type OpEnum = zod.input<typeof OpEnum>;
export type OpEnumOutput = zod.output<typeof OpEnum>;
